export default __webpack_public_path__ + "static/media/matiere.f799df44.svg";